import React from 'react';
import cn from 'classnames';
import { CancellationFlowStep } from 'store/dashboard/types';
import { useDispatch, useSelector } from 'react-redux';
import getCancellationResult from 'store/dashboard/selector/getCancellationResult';
import fetchSubscriptionDataOperation from 'store/dashboard/operation/fetchSubscriptionDataOperation';
import { setCancellationFlowStep } from 'store/dashboard/slice';
import styles from './CancellationResult.module.scss';

const EMAIL_PLACEHOLDER = '{email}';
const DATE_PLACEHOLDER = '{opplus_enddate}';

const CancellationResult = () => {
  const dispatch = useDispatch();
  const cancellationResult = useSelector(getCancellationResult);

  const setStep = (step: CancellationFlowStep) => dispatch(setCancellationFlowStep(step));

  if (!cancellationResult) {
    return null;
  }

  const descriptionHtml = cancellationResult.description.replace(
    DATE_PLACEHOLDER,
    `<b>${cancellationResult.endDate}</b>`,
  );

  const emailConfirmation = cancellationResult.confirmationEmailMsg.replace(
    EMAIL_PLACEHOLDER,
    `<span>${cancellationResult.email}</span>`,
  );

  const showInitialDashboard = () => {
    dispatch(fetchSubscriptionDataOperation());
    setStep(CancellationFlowStep.initial);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>{cancellationResult.title}</h1>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
      <div className={styles.emailConfirmation} dangerouslySetInnerHTML={{ __html: emailConfirmation }} />
      <div className={styles.actions}>
        <button className={cn(styles.action, styles['action--secondary'])} onClick={() => showInitialDashboard()}>
          {cancellationResult.txtDoneButton}
        </button>
      </div>
    </div>
  );
};

export default CancellationResult;
